export interface Chapter {
  id: string;
  title: string;
  updateTime: string;
  views: string;
}

export interface Comic {
  id: string;
  title: string;
  category: string;
  cover: string;
  description: string;
  author: string;
  status: string;
  rating: string;
  tags: string[];
  lastUpdate: string;
  chapters: Chapter[];
}

export const categoryList = [
  { key: "all", name: "全部", icon: "ri-grid-fill" },
  { key: "action", name: "热血动作", icon: "ri-fire-fill" },
  { key: "fantasy", name: "玄幻修真", icon: "ri-sparkling-2-fill" },
  { key: "romance", name: "恋爱日常", icon: "ri-heart-fill" },
  { key: "mystery", name: "悬疑推理", icon: "ri-search-eye-fill" },
  { key: "comedy", name: "搞笑日常", icon: "ri-emotion-happy-fill" },
  { key: "sci-fi", name: "科幻末世", icon: "ri-rocket-fill" },
];

export const comics: Comic[] = [
  {
    id: "cangqiong-jianzhu",
    title: "苍穹剑帝",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=anime%20fantasy%20swordmaster%20young%20man%20standing%20on%20mountain%20peak%20with%20glowing%20sword%2C%20dramatic%20sky%2C%20epic%20xianxia%20manga%20cover%20art%2C%20clean%20composition%2C%20vivid%20ink%20painting%20style%2C%20portrait%20cover%20illustration&width=600&height=800&seq=comic-cover-cangqiong&orientation=portrait",
    description: "少年剑心被废后偶得上古剑诀，于苍穹之上逆天改命。一柄凡铁，斩尽诸天神魔，从此剑指苍穹，问鼎帝路。",
    author: "墨白工作室",
    status: "连载中",
    rating: "9.6",
    tags: ["玄幻", "热血", "逆袭"],
    lastUpdate: "3小时前更新",
    chapters: [
      { id: "cj-001", title: "第1话 废剑少年", updateTime: "2026-08-16", views: "12.6万" },
      { id: "cj-002", title: "第2话 上古剑诀", updateTime: "2026-08-15", views: "11.9万" },
      { id: "cj-003", title: "第3话 一剑破空", updateTime: "2026-08-13", views: "10.2万" },
      { id: "cj-004", title: "第4话 剑冢惊变", updateTime: "2026-08-11", views: "9.8万" },
      { id: "cj-005", title: "第5话 帝路初启", updateTime: "2026-08-08", views: "9.1万" },
    ],
  },
  {
    id: "rexue-xueyuan",
    title: "热血学园",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=energetic%20anime%20school%20boy%20in%20martial%20arts%20uniform%20throwing%20punch%2C%20dynamic%20motion%2C%20sports%20manga%20cover%2C%20bright%20warm%20colors%2C%20clean%20background%2C%20action%20comic%20illustration&width=600&height=800&seq=comic-cover-rexue&orientation=portrait",
    description: "平凡少年入学武道学园，在一次次对决中觉醒斗志。友情、热血、汗水，属于青春的最强传说就此拉开帷幕。",
    author: "燃魂动漫",
    status: "连载中",
    rating: "9.4",
    tags: ["校园", "热血", "竞技"],
    lastUpdate: "1天前更新",
    chapters: [
      { id: "rx-001", title: "第1话 入学试炼", updateTime: "2026-08-15", views: "15.2万" },
      { id: "rx-002", title: "第2话 第一场对决", updateTime: "2026-08-12", views: "14.0万" },
      { id: "rx-003", title: "第3话 觉醒", updateTime: "2026-08-09", views: "13.1万" },
      { id: "rx-004", title: "第4话 团队之战", updateTime: "2026-08-05", views: "12.0万" },
    ],
  },
  {
    id: "xinghai-qiuji",
    title: "星海求生",
    category: "sci-fi",
    cover: "https://readdy.ai/api/search-image?query=astronaut%20alone%20on%20barren%20alien%20planet%20with%20giant%20red%20moon%20in%20sky%2C%20survival%20sci-fi%20manga%20cover%2C%20dark%20blue%20and%20orange%20tones%2C%20cinematic%20clean%20composition%2C%20detailed%20illustration&width=600&height=800&seq=comic-cover-xinghai&orientation=portrait",
    description: "一艘坠毁的星舰，一群失散的幸存者。在陌生星域中求生，资源争夺与人性考验不断上演，谁能活着回家？",
    author: "远航工作室",
    status: "已完结",
    rating: "9.2",
    tags: ["科幻", "生存", "冒险"],
    lastUpdate: "3天前更新",
    chapters: [
      { id: "xh-001", title: "第1话 坠落", updateTime: "2026-08-13", views: "8.9万" },
      { id: "xh-002", title: "第2话 陌生星域", updateTime: "2026-08-10", views: "8.2万" },
      { id: "xh-003", title: "第3话 资源之争", updateTime: "2026-08-06", views: "7.5万" },
      { id: "xh-004", title: "第4话 回家的路", updateTime: "2026-08-01", views: "7.0万" },
    ],
  },
  {
    id: "dushi-yixian",
    title: "都市医仙",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=handsome%20modern%20man%20in%20white%20coat%20with%20glowing%20green%20energy%20in%20palm%2C%20city%20background%20bokeh%2C%20urban%20fantasy%20manga%20cover%2C%20mystic%20and%20modern%20mix%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-dushiyixian&orientation=portrait",
    description: "医道宗师回归都市，以一手回春妙术纵横商场与江湖。悬壶济世之外，更有恩怨情仇待他一一化解。",
    author: "青囊画社",
    status: "连载中",
    rating: "9.1",
    tags: ["都市", "修真", "逆袭"],
    lastUpdate: "2天前更新",
    chapters: [
      { id: "dy-001", title: "第1话 医者归来", updateTime: "2026-08-14", views: "10.8万" },
      { id: "dy-002", title: "第2话 妙手回春", updateTime: "2026-08-11", views: "10.1万" },
      { id: "dy-003", title: "第3话 都市风云", updateTime: "2026-08-07", views: "9.3万" },
    ],
  },
  {
    id: "zhentan-she",
    title: "侦探社物语",
    category: "mystery",
    cover: "https://readdy.ai/api/search-image?query=young%20detective%20with%20magnifying%20glass%20in%20moody%20dark%20study%20room%20with%20bookshelves%2C%20mystery%20manga%20cover%2C%20teal%20and%20shadow%20tones%2C%20clean%20composition%2C%20detective%20illustration&width=600&height=800&seq=comic-cover-zhentan&orientation=portrait",
    description: "一间不起眼的侦探社，藏着这座城市最深的秘密。搭档二人组抽丝剥茧，在迷雾中还原每一个真相。",
    author: "迷雾岛",
    status: "连载中",
    rating: "9.5",
    tags: ["悬疑", "推理", "都市"],
    lastUpdate: "5小时前更新",
    chapters: [
      { id: "zt-001", title: "第1话 委托人", updateTime: "2026-08-16", views: "13.5万" },
      { id: "zt-002", title: "第2话 失踪的画", updateTime: "2026-08-14", views: "12.4万" },
      { id: "zt-003", title: "第3话 时间的证词", updateTime: "2026-08-12", views: "11.6万" },
      { id: "zt-004", title: "第4话 迷雾解开", updateTime: "2026-08-09", views: "10.8万" },
    ],
  },
  {
    id: "yuangqi-shaonv",
    title: "元气少女日常",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=cheerful%20anime%20schoolgirl%20with%20long%20hair%20smiling%20with%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20romance%20manga%20cover%2C%20warm%20sunny%20background%2C%20clean%20and%20bright%20illustration&width=600&height=800&seq=comic-cover-yuanqi&orientation=portrait",
    description: "元气满满的少女转学而来，平静的校园从此热闹起来。青涩的心动、友情的暖意，每天都在悄悄发生。",
    author: "甜橙漫画",
    status: "连载中",
    rating: "9.3",
    tags: ["恋爱", "校园", "治愈"],
    lastUpdate: "6小时前更新",
    chapters: [
      { id: "yq-001", title: "第1话 转学生", updateTime: "2026-08-16", views: "16.8万" },
      { id: "yq-002", title: "第2话 邻座的你", updateTime: "2026-08-13", views: "15.5万" },
      { id: "yq-003", title: "第3话 心跳加速", updateTime: "2026-08-10", views: "14.6万" },
    ],
  },
  {
    id: "baoxiao-qinshi",
    title: "爆笑寝室",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=funny%20group%20of%20college%20roommates%20laughing%20in%20messy%20dorm%20room%2C%20cartoon%20comedy%20manga%20cover%2C%20bright%20yellow%20and%20warm%20tones%2C%20clean%20playful%20illustration&width=600&height=800&seq=comic-cover-baoxiao&orientation=portrait",
    description: "四个性格迥异的室友，一间永远在鸡飞狗跳的寝室。爆笑日常持续上演，看他们如何互相'伤害'又彼此支撑。",
    author: "四格社",
    status: "连载中",
    rating: "9.0",
    tags: ["搞笑", "校园", "日常"],
    lastUpdate: "1天前更新",
    chapters: [
      { id: "bx-001", title: "第1话 室友请多指教", updateTime: "2026-08-15", views: "12.2万" },
      { id: "bx-002", title: "第2话 查寝风云", updateTime: "2026-08-11", views: "11.3万" },
      { id: "bx-003", title: "第3话 期末大作战", updateTime: "2026-08-06", views: "10.5万" },
    ],
  },
  {
    id: "jijia-jiyuan",
    title: "机甲纪元",
    category: "sci-fi",
    cover: "https://readdy.ai/api/search-image?query=giant%20mecha%20robot%20battling%20at%20sunset%20city%20skyline%2C%20mecha%20sci-fi%20manga%20cover%2C%20dramatic%20orange%20and%20steel%20tones%2C%20clean%20dynamic%20composition%2C%20detailed%20illustration&width=600&height=800&seq=comic-cover-jijia&orientation=portrait",
    description: "机甲驾驶的天才少年，承载着人类最后的希望。在终焉纪元，与宿命之敌展开一场关乎存亡的决战。",
    author: "铁幕工作室",
    status: "连载中",
    rating: "9.4",
    tags: ["科幻", "机甲", "热血"],
    lastUpdate: "8小时前更新",
    chapters: [
      { id: "jj-001", title: "第1话 觉醒", updateTime: "2026-08-16", views: "14.4万" },
      { id: "jj-002", title: "第2话 初阵", updateTime: "2026-08-13", views: "13.2万" },
      { id: "jj-003", title: "第3话 战友", updateTime: "2026-08-09", views: "12.5万" },
    ],
  },
  {
    id: "quanwang-zhilu",
    title: "拳王之路",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=muscular%20boxer%20in%20boxing%20ring%20with%20red%20gloves%2C%20sweat%20and%20intense%20expression%2C%20boxing%20sports%20manga%20cover%2C%20dark%20red%20and%20warm%20tones%2C%20clean%20dramatic%20illustration&width=600&height=800&seq=comic-cover-quanwang&orientation=portrait",
    description: "从街边少年到拳坛王者，一场又一场硬仗铸就传奇。挥出的每一拳，都是对命运最有力的回击。",
    author: "燃魂动漫",
    status: "已完结",
    rating: "9.5",
    tags: ["热血", "竞技", "成长"],
    lastUpdate: "2天前更新",
    chapters: [
      { id: "qw-001", title: "第1话 擂台之上", updateTime: "2026-08-14", views: "13.9万" },
      { id: "qw-002", title: "第2话 十连胜", updateTime: "2026-08-10", views: "12.8万" },
      { id: "qw-003", title: "第3话 宿敌", updateTime: "2026-08-04", views: "12.0万" },
    ],
  },
  {
    id: "qiyue-zhi-lian",
    title: "契约之恋",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=anime%20couple%20holding%20hands%20under%20starlit%20night%20sky%2C%20romantic%20manga%20cover%2C%20soft%20purple%20and%20warm%20pink%20tones%2C%20clean%20dreamy%20composition%2C%20romance%20illustration&width=600&height=800&seq=comic-cover-qiyue&orientation=portrait",
    description: "一场意外的契约，让两个世界的人走到了一起。从假扮情侣到真心相许，这条路上满是温柔与心动。",
    author: "甜橙漫画",
    status: "连载中",
    rating: "9.1",
    tags: ["恋爱", "都市", "甜宠"],
    lastUpdate: "4小时前更新",
    chapters: [
      { id: "qy-001", title: "第1话 一纸契约", updateTime: "2026-08-16", views: "15.1万" },
      { id: "qy-002", title: "第2话 同居生活", updateTime: "2026-08-12", views: "14.0万" },
      { id: "qy-003", title: "第3话 心动时刻", updateTime: "2026-08-08", views: "13.3万" },
    ],
  },
  {
    id: "miwu-yian",
    title: "迷雾疑案",
    category: "mystery",
    cover: "https://readdy.ai/api/search-image?query=rainy%20night%20city%20street%20with%20silhouette%20of%20investigator%20holding%20umbrella%2C%20noir%20mystery%20manga%20cover%2C%20cold%20blue%20and%20moody%20tones%2C%20clean%20atmospheric%20illustration&width=600&height=800&seq=comic-cover-miwu&orientation=portrait",
    description: "连环疑案笼罩城市，每个线索都指向意想不到的方向。真相藏在层层迷雾之中，等待勇敢者去揭开。",
    author: "迷雾岛",
    status: "连载中",
    rating: "9.2",
    tags: ["悬疑", "推理", "刑侦"],
    lastUpdate: "2天前更新",
    chapters: [
      { id: "mw-001", title: "第1话 雨夜来客", updateTime: "2026-08-14", views: "11.7万" },
      { id: "mw-002", title: "第2话 不在场证明", updateTime: "2026-08-09", views: "10.9万" },
      { id: "mw-003", title: "第3话 迷雾之后", updateTime: "2026-08-02", views: "10.2万" },
    ],
  },
  {
    id: "yaoguai-zahuodian",
    title: "妖怪杂货店",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=cute%20spirit%20creatures%20and%20shopkeeper%20in%20magical%20little%20grocery%20shop%2C%20warm%20glowing%20lanterns%2C%20fantasy%20comedy%20manga%20cover%2C%20cozy%20colorful%20tones%2C%20clean%20whimsical%20illustration&width=600&height=800&seq=comic-cover-yaoguai&orientation=portrait",
    description: "每当夜幕降临，街角的杂货店便迎来一群不速之客。店主与各路妖怪斗智斗勇，笑闹间温暖人心。",
    author: "四格社",
    status: "连载中",
    rating: "9.0",
    tags: ["搞笑", "奇幻", "治愈"],
    lastUpdate: "1天前更新",
    chapters: [
      { id: "yg-001", title: "第1话 夜半来客", updateTime: "2026-08-15", views: "9.9万" },
      { id: "yg-002", title: "第2话 会说话的猫", updateTime: "2026-08-10", views: "9.2万" },
      { id: "yg-003", title: "第3话 妖怪的委托", updateTime: "2026-08-05", views: "8.6万" },
    ],
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(tag: string): Comic[] {
  if (tag === "all") return comics;
  return comics.filter((c) => c.category === tag);
}